import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ffed03b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "listing-sidebar" }
const _hoisted_2 = { class: "listing-sidebar__search" }
const _hoisted_3 = { class: "listing-sidebar__date" }

import { onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import PatientListing from '@/widgets/WPatientSidebar/components/PatientListing.vue'
import { PatientListingType, PatientFilterType } from '@/shared/types'
import { patientApi, reportApi } from '@/shared/api/'
import { usePatientListing } from '@/shared/composables'
import { showErrorMessage } from '@/shared/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const loading = ref(false)

const searchingData = ref<string>()
const dateRange = ref([])

const patients = ref<PatientListingType>({
  withoutPatientCount: 0,
  patients: [],
})

const { isPatientListingUpdated, updatePatientListing } = usePatientListing()

const patientFilters: PatientFilterType = {
  dateFrom: undefined,
  dateTo: undefined,
  search: '',
}

watch(
  () => isPatientListingUpdated.value,
  (isUpdated) => {
    if (isUpdated) {
      getPatientListing()
      updatePatientListing(false)
    }
  }
)

const handleInputSearch = (): void => {
  const minCountLettersSearch = 2
  const resetValueSearch = 0

  if (
    searchingData.value.length > minCountLettersSearch ||
    searchingData.value.length === resetValueSearch
  ) {
    getPatientListing()
  }
}

const getPatientListing = async (): Promise<void> => {
  loading.value = true

  patientFilters.search = searchingData.value

  if (dateRange.value?.length) {
    patientFilters.dateFrom = new Date(
      dateRange.value[0] - dateRange.value[0].getTimezoneOffset() * 60000
    )
    patientFilters.dateTo = new Date(
      dateRange.value[1] - dateRange.value[1].getTimezoneOffset() * 60000
    )
    router.push({ name: 'PatientListingPage' })
  } else {
    patientFilters.dateFrom = undefined
    patientFilters.dateTo = undefined
  }

  const [error, response] = await patientApi.getPatientListing(patientFilters)

  if (error) {
    showErrorMessage(error)
    patients.value.patients = []
  } else {
    patients.value.withoutPatientCount = await getCountReportsWithoutPatient()
    patients.value.patients = response.data.patients
  }

  loading.value = false
}

const getCountReportsWithoutPatient = async (): Promise<number> => {
  const [error, response] = await reportApi.getReportsWithoutPatient()

  if (!error) {
    return response.data.reports.length
  }

  return 0
}

onMounted((): void => {
  getPatientListing()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        modelValue: searchingData.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchingData).value = $event)),
        size: "small",
        placeholder: "Поиск по фамилии/№ медкарты",
        clearable: "",
        onInput: handleInputSearch
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_date_picker, {
        modelValue: dateRange.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dateRange).value = $event)),
        size: "small",
        type: "daterange",
        "start-placeholder": "Начало",
        "end-placeholder": "Конец",
        format: "DD.MM.YYYY",
        onChange: getPatientListing
      }, null, 8, ["modelValue"])
    ]),
    _withDirectives(_createVNode(PatientListing, {
      class: "listing-sidebar__listing",
      "patient-list": patients.value
    }, null, 8, ["patient-list"]), [
      [_directive_loading, loading.value]
    ])
  ]))
}
}

})